<template>
  <v-flex class="client-saved-search">
    <v-card>
      <v-card-title class="card-title">
        Saved Search
        <span @click="createSearch">CREATE SEARCH</span>
      </v-card-title>
      <v-divider />
      <v-flex class="client-saved-info" :class="{'centered-button': !savedSearch}">
        <v-flex v-if="savedSearch">
          <v-card-text class="search-container">
            <div class="search-list">
              <template v-for="key in Object.keys(getSearchValues)">
                <span :key="key">
                  <span>{{ key }}: <em>{{ getSearchValues[key] }}</em></span>
                </span>
              </template>
            </div>
          </v-card-text>
        </v-flex>
        <v-card-text v-else class="no-search">
          <span>User don`t have saved search</span>
        </v-card-text>
        <v-card-actions v-if="savedSearch">
          <v-btn
            :color="colors.hwayzBrandBlue"
            class="white--text create-search-btn"
            @click.stop="openSavedSearch"
          >
            SAVED SEARCH
          </v-btn>
        </v-card-actions>
      </v-flex>
    </v-card>
  </v-flex>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { getCustomFieldValue } from '../../../services/autoSearchService'
import colors from '../../../scss/_colors.scss'

export default {
  props: {
    savedSearch: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors,
      search: true
    }
  },
  computed: {
    ...mapState('client', ['clientData']),
    ...mapState('common', ['searchObject']),

    getSearchValues() {
      if (this.savedSearch) {
        const query = this.savedSearch.query
        const obj = Object.keys(query).reduce((val, key) => {
          // if no value does not add in obj
          if (!query[key] && typeof query[key] !== 'boolean') return val

          if (Array.isArray(query[key])) {
            // if empty array does not add
            if (!query[key].length) return val
            // add array as string
            val[key] = query[key].toString()
            return val
          }
          // add value
          val[key] = getCustomFieldValue(key, query[key], this.searchObject.searchType)
          return val
        }, {})
        return obj
      }
      return null
    }
  },

  methods: {
    ...mapMutations('client', {
      setAssignToClient: 'SET_ASSIGN_TO_CLIENT'
    }),
    ...mapMutations('common', {
      setNewRequestedQuery: 'SET_NEW_REQUESTED_QUERY',
      setSearchResultPage: 'SET_SEARCH_RESULT_PAGE'
    }),

    createSearch() {
      this.setAssignToClient(this.clientData)
      this.setSearchResultPage(true)
      this.$router.push({ name: 'agent-search' })
    },
    openSavedSearch() {
      this.setAssignToClient(this.clientData)
      this.setNewRequestedQuery(this.savedSearch.query)
      this.setSearchResultPage(true)
      this.$router.push({ name: 'agent-search' })
    }
  }
}
</script>

<style lang="sass">
.client-saved-search
  height: 100%
  display: flex
  flex-grow: 1
  align-items: stretch
.client-saved-search .v-card
  width: 100%
.client-saved-search .v-btn
  font-weight: 500 !important
.create-search-btn
  border-radius: 5px
.search-container
  padding: 10px
.client-saved-info
  padding: 10px 10px 15px
  height: calc(100% - 41px)
.centered-button
  display: flex
  justify-content: center
  align-items: center
.search-list
  text-align: left
  padding: 10px 5px
  border: 1px solid rgba(0,0,0,0.12)
  display: flex
  flex-wrap: wrap
  width: 100%

.no-search
  width: 100%
  text-align: center
  color: #ccc

.search-list
  column-count: 2
  span
    display: inline-block
    width: 100%
    em
      color: rgba(0,0,0,0.5)
      font-style: normal
</style>
